import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useAiFilterStore } from "@src/store/AiFilterStore";
import { useAiRecommendFilterStore, useUserAiSettingSotre } from "@src/store/AiRecommendFilterStore";
import { Common } from "@src/styles/Common";
import React from "react";

type AiFooterPropsType = {
    isPrev?: boolean;
    isReset?: boolean;
    isNext?: boolean;
    isShowList?: boolean;
    onClickNext?: () => void;
    onClickReset?: () => void;
    onClickPrev?: () => void;
    onClickShowList?: () => void;
    style: any;
    step: number;
};

const AiRecommendFooter = ({
    isPrev,
    isReset,
    isNext,
    isShowList,
    onClickNext,
    onClickReset,
    onClickPrev,
    onClickShowList,
    style,
    step,
}: AiFooterPropsType) => {
    const userAiSettingFilterState = useUserAiSettingSotre((state) => state.userAiSettingState);
    return (
        <div css={Container} style={style}>
            {isReset && (
                <button onClick={onClickReset} className="reset">
                    전체 초기화
                </button>
            )}
            {isPrev && (
                <button onClick={onClickPrev} className="prev">
                    이전
                </button>
            )}
            {isNext && (
                <button
                    onClick={onClickNext}
                    style={{ flex: !isPrev ? 2 : 1 }}
                    className={
                        (step === 2 && !userAiSettingFilterState?.investmentPrice) ||
                        (step === 3 && userAiSettingFilterState?.regions.length === 0) ||
                        (step === 4 && userAiSettingFilterState?.categories.length === 0)
                            ? "disabled"
                            : "next"
                    }
                    disabled={
                        (step === 2 && !userAiSettingFilterState?.investmentPrice) ||
                        (step === 3 && userAiSettingFilterState?.regions.length === 0) ||
                        (step === 4 && userAiSettingFilterState?.categories.length === 0)
                    }
                >
                    다음
                </button>
            )}
            {isShowList && (
                <button onClick={onClickShowList} className="showList">
                    매물보기
                </button>
            )}
        </div>
    );
};

export default AiRecommendFooter;

const Container = css`
    position: absolute;
    width: calc(100% - 2px);
    bottom: 0;
    margin-left: -13px;
    flex: 1;
    display: flex;
    row-gap: 12px;
    background-color: #ffffff;
    button {
        flex: 1;
        height: 54px;
        border-radius: 14px;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 0px;
        text-align: center;
    }

    button + button {
        margin-left: 12px;
    }
    .reset {
        background: #fbf8f8;
    }

    .prev {
        background: ${Common.colors.bgMint};
    }

    .next {
        background: ${Common.colors.aucMarkerColor};
        color: white;
    }
    .showList {
        background: ${Common.colors.aucMarkerColor};
        color: white;
    }
    .disabled {
        background: #dadada;
        color: #0c002c;
    }
`;
